module.exports = __webpack_public_path__ + "static/media/yougotthis.85bed11e.gif";